import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Loan1008Model } from './models/loan-1008.model';
import { catchError, throwError } from 'rxjs';
import { APP_ENV } from 'apps/cmg-clear2-ui/src/environments/environment.model';

@Injectable({
  providedIn: 'root',
})
export class Loan1008Service {
  private readonly _httpClient = inject(HttpClient);
  private readonly _environment = inject(APP_ENV);

  getLoan1008data(fileId: number) {
    const url = `${this._environment.retail.apiUrl}/1oan1008/file/${fileId}`;
    return this._httpClient.get<Loan1008Model>(url).pipe(catchError(this.error));
  }

  // Handle Errors
  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => {
      return errorMessage;
    });
  }
}
